export function modal() {

  let width = window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth;

  if(width <= 768) {
    return;
  }

  let modal = document.querySelector('.js-modal');
  let modalBtn = document.querySelector('.js-modalBtn');
  let modalClose = document.querySelector('.js-modalClose');

  modalBtn.addEventListener('click', ()=>{
    modal.classList.add('is-active');
  });

  modalClose.addEventListener('click', ()=>{
    modal.classList.remove('is-active');
  });
}
